// @ts-nocheck
import { handleError } from '@/utilities';
import { ConsentActions, ConsentStates } from '../constants/consent';
import { ConsentProxy } from '../proxies';
import store from '../store';
import Events from '../constants/events';

async function addImpliedConsentTypes() {
  const {
    config: { regionTemplate: { suppressImplied = false } = {} } = {},
    consentState,
    consentTypes,
  } = store;

  if (suppressImplied) {
    return;
  }

  const impliedTypes = consentTypes.filter(
    ({ id, validStates }) =>
      validStates.includes(ConsentStates.implied) && !consentState.hasState(id),
  );

  if (impliedTypes.length === 0) {
    return;
  }

  const events = impliedTypes
    .filter((consentType) => !consentState.hasState(consentType.id))
    .map((consentType) => ({
      consentType: consentType.id,
      consentState: ConsentStates.implied,
      consentAction: ConsentActions.implied,
    }));
  if (events.length > 0) {
    await ConsentProxy.addConsentEvents(events);
  }
}

const getState = ({ subcategory }) =>
  ['do_not_sell', 'limit_pii_use'].includes(subcategory)
    ? 'declined'
    : 'accepted';

async function addImpliedPrivacySettings() {
  const {
    config: {
      regionTemplate: {
        settings: { consent: { blockingMode, consentMode, gpc } = {} } = {},
      } = {},
    } = {},
    consentState,
    consentTypes,
  } = store;
  if (
    blockingMode !== 'disabled' &&
    blockingMode !== 'discovery' &&
    consentMode === 'implied'
  ) {
    const categories = consentTypes
      .filter(
        ({ id, category, subcategory, label }) =>
          category === 'privacy_setting' &&
          label === 'consent' &&
          !['limit_pii_use'].includes(subcategory) &&
          !consentState.hasState(id),
      )
      .reduce(
        (acc, cat) => ({
          ...acc,
          [cat.subcategory]: {
            category: cat.category,
            subcategory: cat.subcategory,
            label: cat.label,
            consentState: getState(cat),
            consentAction: ConsentActions.implied,
          },
        }),
        {},
      );

    if (categories.length !== 0) {
      if (gpc && categories.do_not_sell) {
        const gpcValue = navigator.globalPrivacyControl;
        if (gpcValue) {
          categories.do_not_sell.consentState = 'accepted';
          // this is created as it may have been filtered above
          // as already in state
          categories.marketing = {
            category: 'privacy_setting',
            subcategory: 'marketing',
            label: 'consent',
            consentState: 'declined',
            consentAction: ConsentActions.implied,
          };
          categories.global_privacy_control = {
            category: 'privacy_setting',
            subcategory: 'global_privacy_control',
            label: 'detected',
            consentState: 'accepted',
            consentAction: ConsentActions.implied,
          };
        } else {
          delete categories.do_not_sell;
        }
      }
      const events = Object.values(categories);
      if (events.length > 0) {
        await ConsentProxy.addConsentEvents(events);
      }
    }
  }
}

async function addEvents() {
  const {
    consentState: { consentState },
    consentTypes,
  } = store;

  if (consentState && consentTypes) {
    addImpliedConsentTypes();
    addImpliedPrivacySettings();
  }
}

export async function addImpliedConsentEvents() {
  try {
    const { consentTypes, consentState } = store;

    if (!consentTypes || consentTypes.length === 0) {
      window.addEventListener(Events.ConsentTypesLoaded, addEvents, {
        once: true,
      });
      return null;
    }
    if (consentState.consentState === null) {
      window.addEventListener(Events.ConsentStateLoaded, addEvents, {
        once: true,
      });
      return null;
    }
    return addEvents();
  } catch (err) {
    handleError(err);
  }
  return null;
}
